<template>
  <div class="container-fluid bg-light-gray h-100">
    <div class="row">
      <div class="col">
        <h6 class="pt-3 title-color font-weight-bold">
          <span class="bg-white p-2 rounded-circle">
            <i class="fas fa-user-tie orange-icon" />
          </span>
          Búsqueda de Asistente de Salón Especial
        </h6>
      </div>
    </div>
    <div class="row p-3">
      <div class="col-12 col-md-4 col-lg-4">
        <ValidationProvider v-slot="{ errors }" name="Region" rules="required">
          <label class="text-muted mb-1">Región:</label>
          <CustomDropDown
            v-model="model.region"
            placeholder="Seleccione"
            class="placeholder-black"
            fieldkey="id"
            fieldname="name"
            :options="collections.regions"
            :disabled="isDropDownRegionDisabled"
            :error="errors[0]"
            @input="onChangeRegion"
          />
          <CustomError
            v-if="errors[0]"
            variant="no-border"
            message="Favor seleccione una región."
          />
        </ValidationProvider>
      </div>

      <div class="col-12 col-md-4 col-lg-4">
        <ValidationProvider
          v-slot="{ errors }"
          name="Municipio"
          rules="required"
        >
          <label class="text-muted mb-1">Municipio:</label>
          <CustomDropDown
            v-model="model.municipality"
            placeholder="Seleccione"
            class="placeholder-black"
            fieldkey="id"
            fieldname="name"
            :options="collections.municipalities"
            :disabled="isDropDownMunicipalityIdDisabled"
            :error="errors[0]"
            @input="onChangeMunicipality"
          />
          <CustomError
            v-if="errors[0]"
            variant="no-border"
            message="Favor seleccione un municipio."
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-4 col-lg-4">
        <ValidationProvider v-slot="{ errors }" name="Escuela" rules="required">
          <label class="text-muted mb-1">Escuela:</label>
          <CustomDropDown
            v-model="model.school"
            placeholder="Seleccione"
            class="placeholder-black"
            fieldkey="id"
            fieldname="name"
            :options="collections.schools"
            :disabled="isDropDownSchoolDisabled"
            :error="errors[0]"
            @input="onChangeSchool"
          />
          <CustomError
            v-if="errors[0]"
            variant="no-border"
            message="Favor seleccione una escuela."
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-4 col-lg-4">
        <ValidationProvider
          v-slot="{ errors }"
          name="Nombre maestro"
          rules="required"
        >
          <label class="text-muted mb-1">Nombre del maestro:</label>
          <CustomDropDown
            v-model="model.custodian"
            placeholder="Seleccione"
            class="placeholder-black"
            fieldkey="id"
            fieldname="name"
            :options="collections.custodians"
            :error="errors[0]"
            :disabled="isDropDownCustodianDisabled"
            @input="onChangeCustodian"
          />
          <CustomError
            v-if="errors[0]"
            variant="no-border"
            message="Favor seleccione un maestro."
          />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomError from 'custom-error';
import childCountService from '@/services/api/childCount.api';
import { ValidationProvider } from 'vee-validate';
import locationService from '@/services/api/location.api.js';
import { getSchoolTeacher } from '@/modules/alternative-location-management/api';
import academicYears from '@/utils/constants/academicYears';

export default {
  name: 'SearchByGroup',
  components: {
    CustomDropDown,
    CustomError,
    ValidationProvider,
  },
  props: {
    value: {
      type: [Object],
      default: () => {},
      meta: {
        description: 'Parámetro de entrada del SearchByGroup',
        example: {},
      },
    },
    academicYearId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    model: {
      school: null,
      custodian: null,
      region: null,
      municipality: null,
    },
    collections: {
      schools: [],
      custodians: [],
      regions: [],
      municipalities: [],
    },
  }),
  computed: {
    isDropDownSchoolDisabled() {
      return this.collections.schools && this.collections.schools.length <= 1;
    },
    isDropDownRegionDisabled() {
      return this.collections.regions && this.collections.regions.length <= 1;
    },
    isDropDownMunicipalityIdDisabled() {
      return (
        this.collections.municipalities &&
        this.collections.municipalities.length <= 1
      );
    },
    isDropDownCustodianDisabled() {
      return (
        this.collections.custodians && this.collections.custodians.length <= 1
      );
    },
  },
  methods: {
    async getCustodianList(locationSchoolId) {
      var teachers = null;
      if (this.academicYearId >= academicYears.Y2022_2023) {
        teachers = await getSchoolTeacher({
          locationSchoolId: locationSchoolId,
        });
      } else {
        teachers = await childCountService.getSchoolCustodian(locationSchoolId);
      }

      if (teachers.data) {
        this.collections.custodians = teachers.data;
        if (
          this.collections.custodians &&
          this.collections.custodians.length == 1
        ) {
          this.model.custodian = this.collections.custodians[0];
        }
      }
    },
    async onChangeRegion(region) {
      this.model.municipality = null;
      this.model.school = null;
      this.model.custodian = null;
      this.collections.municipalities = [];
      this.collections.schools = [];
      this.collections.custodians = [];
      this.resetForm();
      if (region) {
        await this.fetchMunicipalities(region.id);
      }
    },
    async onChangeMunicipality(municipality) {
      this.model.school = null;
      this.model.custodian = null;
      this.collections.schools = [];
      this.collections.custodians = [];
      this.resetForm();
      if (municipality) {
        await this.fetchSchools(municipality.id);
      }
    },
    async onChangeSchool(school) {
      this.model.custodian = null;
      this.collections.custodians = [];
      this.resetForm();
      if (school) {
        await this.getCustodianList(school.id);
      }
    },
    onChangeCustodian(custodian) {
      this.$emit('input', custodian);
      this.resetForm();
    },
    resetForm() {
      this.$parent.reset && this.$parent.reset();
    },
    async fetchRegions(academicYearId) {
      const { data } = await locationService.getRegions({ academicYearId });
      this.collections.regions = data;
      if (this.collections.regions && this.collections.regions.length == 1) {
        this.model.region = this.collections.regions[0];
        await this.fetchMunicipalities(this.model.region.id);
      }
    },
    async fetchMunicipalities(regionId) {
      const { data } = await locationService.getMunicipalities({
        regionId,
        academicYearId: this.academicYearId,
      });
      this.collections.municipalities = data;
      if (
        this.collections.municipalities &&
        this.collections.municipalities.length == 1
      ) {
        this.model.municipality = this.collections.municipalities[0];
        await this.fetchSchools(this.model.municipality.id);
      }
    },
    async fetchSchools(municipalityId) {
      const { data } = await locationService.getSchoolsWithCustodian({
        municipalityId,
        academicYearId: this.academicYearId,
      });
      this.collections.schools = data;
      if (this.collections.schools && this.collections.schools.length == 1) {
        this.model.school = this.collections.schools[0];
        await this.getCustodianList(this.model.school.id);
      }
    },
  },
  async created() {
    await this.fetchRegions(this.academicYearId);
  },
};
</script>

<style scoped>
.mt-24px {
  margin-top: 24px;
}
.orange-icon {
  color: #ff7058;
}
.title-color {
  color: #3f5b60;
}
::v-deep .placeholder-black input::placeholder {
  color: black;
}
</style>
